var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.82,
    height: 14.82,
    viewBox: "0 0 14.82 14.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -27.408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.663,32.326l-4.234-4.742a.481.481,0,0,0-.744,0A.606.606,0,0,0,9.527,28v2.371H7.675q-5.9,0-7.236,3.733A9.356,9.356,0,0,0,0,37.189a12.178,12.178,0,0,0,1.05,4.177q.025.065.087.222t.112.278a1.086,1.086,0,0,0,.108.2.279.279,0,0,0,.232.158.231.231,0,0,0,.194-.093.372.372,0,0,0,.07-.231,2.106,2.106,0,0,0-.021-.246,2.139,2.139,0,0,1-.021-.218q-.041-.63-.041-1.139a8.8,8.8,0,0,1,.145-1.676,5.445,5.445,0,0,1,.4-1.283,3.192,3.192,0,0,1,.662-.935,3.875,3.875,0,0,1,.872-.644,4.379,4.379,0,0,1,1.1-.394,9.433,9.433,0,0,1,1.274-.2q.641-.056,1.451-.056H9.527v2.371a.605.605,0,0,0,.157.417.482.482,0,0,0,.744,0l4.234-4.743a.632.632,0,0,0,0-.834Z",
    transform: "translate(0)",
    fill: "#818c9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.313c464c9c31e010b11add2c8a07e436.svg";
export { ForwardRef as ReactComponent };